class MRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    let cookie = getCookie("m-recent-viewed-products");
    if (!cookie) return;

    let currentHandle = this.dataset.productHandle;
    let handles = Array.from(new Set(JSON.parse(cookie)));
    if (currentHandle) {
      handles = handles.filter((h) => h !== currentHandle);
    }

    this.filteredHandles = [];

    // Fetch each product's data and exclude 'addons' tagged ones
    Promise.all(
      handles.map(async (handle) => {
        const url = `/products/${handle}.js`;
        try {
          const res = await fetch(url);
          const data = await res.json();

          const tags = data.tags.map(t => t.toLowerCase());
          if (!tags.includes("addons")) {
            this.filteredHandles.push(handle);
          }
        } catch (err) {
          console.error("Error fetching product:", handle, err);
        }
      })
    ).then(() => {
      if (this.filteredHandles.length === 0) {
        this.style.display = "none"; // Hide if no valid products
        return;
      }

      // Show only non-addon products
      this.productList = new MinimogTheme.ProductList(this, this.filteredHandles);
      this.style.display = ""; // Just in case it was hidden
    });
  }
}

customElements.define("m-recently-viewed", MRecentlyViewed);
